<template>
    <li
        class="c-form_list_item">
        <router-link v-if="to" :to="to" class="c-form_list_item-content">
            <slot></slot>
        </router-link>
        <span v-else class="c-form_list_item-content">
      <slot></slot>
    </span>
        <button
            v-if="!hideDelete"
            type="button"
            class="c-form_list_item-delete"
            @click="$emit('delete')">
        </button>
    </li>
</template>


<script>

export default {

    name: 'FormListItem',

    props: {
        to: [String, Object],
        hideDelete: Boolean
    },

    data() {
        return {
            fadeOut: false,
            fadeIn: false
        }
    }

}

</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-form_list_item {
    position: relative;
    display: block;
    margin: 1rem 0;
    width: 100%;
    background-color: #FAFAFC;
    font-size: 0.9rem;
    border-radius: 0.25rem;
    overflow: hidden;
    opacity: 1;
    padding-right: 3rem;
    padding-left: 1rem;

    &-content {
        display: block;
        padding: 0.5rem 0;
        font-weight: 500;
        color: #9FA9BA;
        overflow: hidden;
        text-overflow: ellipsis;

        &:before {
            display: inline-block;
            counter-increment: prokrastynacja;
            content: counter(prokrastynacja) '.';
            font-weight: bold;
            margin-right: .3rem;
        }
    }
    &-delete {
        display: block;
        border: 0;
        background-color: transparent;
        position: absolute;
        top: 50%;
        right: 1.2rem;
        transform: translateY(-50%);
        width: 1rem;
        height: 1rem;
        background-image: url('#{$icons}/delete1.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
    }
}

</style>
